import useSWRMutation from 'swr/mutation';
import { SuccessResponse } from '@interfaces/central-monitoring';
import {
    CreateReviewLogsModel,
    DeleteSubjectReviewLog,
    UpdateSubjectReviewLog,
} from '@interfaces-clean/subject-monitoring/subject-review-log';
import { postData } from '@apis/rest-client';

const subjectReviewLogUrl = 'SubjectMonitoring/SubjectReviewLogs';

const SubjectReviewLogsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(
            `${subjectReviewLogUrl}/Add/${studyRef}`,
            (url: string, { arg }: { arg: CreateReviewLogsModel }) => {
                return postData<CreateReviewLogsModel, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${subjectReviewLogUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateSubjectReviewLog }) => {
                return postData<UpdateSubjectReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(
            `${subjectReviewLogUrl}/Delete/${studyRef}`,
            (url: string, { arg }: { arg: DeleteSubjectReviewLog }) => {
                return postData<DeleteSubjectReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default SubjectReviewLogsApi;
